"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const hookrouter_1 = require("hookrouter");
const WindowDimensionsProvider_1 = __importDefault(require("./components/WindowDimensionsProvider"));
const NavBar_1 = __importDefault(require("./components/NavBar"));
const HomePage_1 = __importDefault(require("./components/HomePage"));
const ImportTimePage_1 = __importDefault(require("./components/ImportTimePage"));
const LogsPage_1 = __importDefault(require("./components/LogsPage"));
const SettingsPage_1 = __importDefault(require("./components/SettingsPage"));
const AuthProvider_1 = require("./components/AuthProvider");
const LoginPage_1 = __importDefault(require("./components/LoginPage"));
const LogoutPage_1 = __importDefault(require("./components/LogoutPage"));
const ErrorScreen_1 = __importDefault(require("./components/ErrorScreen"));
const NotFoundPage_1 = __importDefault(require("./components/NotFoundPage"));
const routes = {
    '/': () => react_1.default.createElement(HomePage_1.default, null),
    '/import-time-entries': () => react_1.default.createElement(ImportTimePage_1.default, null),
    '/logs': () => react_1.default.createElement(LogsPage_1.default, null),
    '/logs/:correlationId': ({ correlationId }) => react_1.default.createElement(LogsPage_1.default, { correlationId: correlationId }),
    '/settings': () => react_1.default.createElement(SettingsPage_1.default, null),
    '/login': () => react_1.default.createElement(LoginPage_1.default, null),
    '/logout': () => react_1.default.createElement(LogoutPage_1.default, null)
};
exports.App = () => {
    const routeResult = hookrouter_1.useRoutes(routes);
    return (!routeResult ?
        react_1.default.createElement(NotFoundPage_1.default, null)
        :
            react_1.default.createElement(ErrorScreen_1.default, null,
                react_1.default.createElement(AuthProvider_1.AuthProvider, null,
                    react_1.default.createElement(WindowDimensionsProvider_1.default, null,
                        react_1.default.createElement(office_ui_fabric_react_1.Stack, { horizontalAlign: "center", verticalAlign: "center", verticalFill: true, styles: { root: { width: '100%', height: 'auto', alignSelf: 'stretch' } } },
                            react_1.default.createElement(office_ui_fabric_react_1.Stack.Item, { align: "stretch" },
                                react_1.default.createElement(NavBar_1.default, null)),
                            react_1.default.createElement(office_ui_fabric_react_1.Stack.Item, { grow: 1, align: "stretch", verticalFill: true, styles: {
                                    root: { backgroundColor: 'white' }
                                } }, routeResult))))));
};
